// API
import form from '@/api/form'

const actions = {
  async setJsonInjetado ({ state, dispatch, commit }, payload) {
    if (state.config.json && Object.keys(state.config.json).length > 0) {
      // Não precisa repopular caso já possua dados
      return
    }
    await commit('SET_JSON_INJETADO', payload)
  },
  async initialize ({ state, dispatch, commit }, payload) {
    await commit('SET_CONFIG', payload)

    if (state.config.jsonForm) {
      commit('GET_FORM_RECEIVE', state.config.jsonForm)
    } else {
      // Verifica se é para recuperar um registro
      if (state.config.idData) {
        await dispatch('getFormDataId', state.config.idData)
        dispatch('getFormVersion', state.formDataId.formVersion)
      } else if (state.config.formVersion) {
        // Verifica se é para recuperar um registro
        dispatch('getFormVersion', state.config.formVersion)
      } else {
        dispatch('getForm')
      }
    }
  },
  async getForm ({ state, commit }) {
    commit('GET_FORM_REQUEST')

    try {
      const response = await form.getForm(state.config.clientKey, state.config.idForm)

      if (response.data.status) {
        commit('GET_FORM_RECEIVE', response.data.data)
      } else {
        commit('FAILURE', response.data)
      }
    } catch (error) {
      return commit('FAILURE', error)
    }
  },
  async getFormVersion ({ state, commit }, formVersion) {
    commit('GET_FORM_VERSION_REQUEST')

    try {
      const response = await form.getFormVersion(state.config.clientKey, state.config.idForm, formVersion)

      if (response.data.status) {
        commit('GET_FORM_VERSION_RECEIVE', response.data.data)
      } else {
        commit('FAILURE', response.data)
      }
    } catch (error) {
      return commit('FAILURE', error)
    }
  },
  async getFormDataId ({ state, commit }, idData) {
    commit('GET_FORM_DATA_ID_REQUEST')

    try {
      const response = await form.getFormDataId(state.config.clientKey, state.config.idForm, idData)

      if (response.data.status) {
        commit('GET_FORM_DATA_ID_RECEIVE', response.data.data)
      } else {
        commit('FAILURE', response.data)
      }
    } catch (error) {
      return commit('FAILURE', error)
    }
  },
  async setShowOnly ({ commit }, payload) {
    commit('SET_SHOW_ONLY', payload)
  }
}

export default actions
